// extracted by mini-css-extract-plugin
export default {"version__wrapper":"Version_version__wrapper__NLkNm"};